import {
  apiGet,
  type ApiRequestOptions,
} from "@softmax/observatory-client/client";
import { ApiError } from "@softmax/observatory-client/transport";
import type { Schemas } from "@softmax/observatory-client/types";

export function getActualViewer({
  signal,
}: {
  signal?: AbortSignal | undefined;
} = {}): Promise<Schemas["WhoAmIResponse"] | null> {
  const options: ApiRequestOptions = { elevatedPrivileges: true };

  if (signal !== undefined) options.signal = signal;

  return apiGet<Schemas["WhoAmIResponse"]>("/whoami", options).then(
    (viewer) => (viewer.subject_type === "user" ? viewer : null),
    (error: unknown) => {
      if (error instanceof ApiError && error.status === 401) return null;

      throw error;
    },
  );
}
